import * as XLSX from "xlsx";
import { fetchAllForExport } from "./listPagination";

function cellValue(row, col) {
  if (col.exportValue) return col.exportValue(row);
  if (col.accessor) {
    const v = col.accessor(row);
    return v == null ? "" : v;
  }
  const key = col.accessorKey || col.id;
  const v = row[key];
  if (v == null || v === "") return "";
  if (typeof v === "object") return JSON.stringify(v);
  return v;
}

/**
 * @param {object[]} rows
 * @param {import('./dataTable').DataTableColumn[]} columns
 * @param {string} filename
 */
export function exportRowsToExcel(rows, columns, filename) {
  const exportCols = columns.filter((c) => c.export !== false && !c.hideInTable);
  const sheetRows = rows.map((row) => {
    const out = {};
    for (const col of exportCols) {
      out[col.label] = cellValue(row, col);
    }
    return out;
  });
  const ws = XLSX.utils.json_to_sheet(sheetRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Export");
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}

/**
 * Download full list (export=1) then write Excel.
 */
export async function exportListToExcel({
  api,
  path,
  params,
  columns,
  filename,
  onError,
}) {
  try {
    const rows = await fetchAllForExport(api, path, params);
    if (!rows.length) {
      onError?.("No rows to export.");
      return;
    }
    exportRowsToExcel(rows, columns, filename);
  } catch (err) {
    onError?.(err?.message || "Export failed");
    throw err;
  }
}
